<template>
    <the-section
        class="offer"
        :id="id"
        :legend="job.title"
        :style="{ color: job.colors['text-secondary'] }"
    >
        <h2 class="title" :style="{ color: job.colors.title }">
            {{ job.subtitle }}
        </h2>
        <p class="text" :style="{ color: job.colors['text-primary'] }">
            {{ job.description }}
        </p>
        <caption-tags :tags="job.tags" :color="job.colors['text-secondary']" />
        <a class="link text" :href="job.link" target="_blank">
            <line-footer />
            <span>Become a <strong>member</strong></span>
            <line-footer />
        </a>
    </the-section>
</template>

<script>
import CaptionTags from "@/components/CaptionTags";
import LineFooter from "@/components/LineFooter";
import TheSection from "@/components/TheSection";
import { clearScroll, scroll } from "@/services/scroll.animation";

export default {
    components: {
        CaptionTags,
        LineFooter,
        TheSection,
    },
    props: {
        job: {
            type: Object,
            required: true,
        },
    },
    computed: {
        id() {
            return `job-offer-${this.job.id}`;
        },
    },
    mounted() {
        scroll(this.id, this.$el, this.job.colors);
    },
    beforeDestroy() {
        clearScroll(this.id);
    },
};
</script>

<style lang="sass" scoped>
@import ~styles/base
@import ~styles/typography

.offer
    display: flex
    flex-direction: column
    justify-content: center
    align-items: left
    min-height: 100vh
    color: white

    +media('>=large')
        justify-content: space-between
        min-height: 100vh
        padding-right: 25%
        padding-left: 25%

.offer
    flex-grow: 1
    display: flex
    flex-direction: column
    justify-content: center

.title
    margin-top: 0
    margin-bottom: calc(var(--line-base) * 1.5)

    +media('<large')
        margin-top: calc(var(--line-base) * 1.5)
        text-align: center

.text
    margin-top: 0
    margin-bottom: 0

.link
    margin-top: var(--line-base)
    margin-left: auto
    display: flex
    flex-direction: column
    align-items: center
    gap: 0.5em
    box-sizing: border-box
    text-align: center
    color: white
    transition: color var(--speed-normal) var(--authentic-motion), border-color var(--speed-normal) var(--authentic-motion)

    +media('<small')
        margin-right: auto

    &:hover
        color: currentColor
        border-color: currentColor

svg
    height: 0.75em
    stroke: currentColor

    &:nth-of-type(2)
        transform: rotate(180deg)
</style>
